import { safetyTips } from '@/mocks/categories';

export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Stay Protected
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Is the Vigorbuy Spreadsheet Safe?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Safety is our top priority. Learn how to identify trusted resources, avoid 
            potential risks, and protect your personal information while shopping through 
            the Vigorbuy Spreadsheet ecosystem.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {safetyTips.map((tip) => (
            <div
              key={tip.risk}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200"
            >
              <div className="flex items-start gap-4">
                <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-shield-check-line text-lg"></i>
                </span>
                <div>
                  <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-2">
                    {tip.risk}
                  </h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {tip.solution}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 md:p-8 rounded-2xl bg-accent-50 border border-accent-200/70 text-center">
          <span className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
            <i className="ri-lightbulb-line text-xl"></i>
          </span>
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
            Pro Tip: Verify Before You Buy
          </h3>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            Always cross-reference QC photos, read recent reviews, and start with smaller 
            orders when trying a new seller. The Vigorbuy Spreadsheet community is here to 
            help — join the discussion and learn from experienced shoppers.
          </p>
        </div>
      </div>
    </section>
  );
}